// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

const StyledListItem = styled<any, Theme>('li')`
  font-size: 1em;
  line-height: 1.2em;
  margin-bottom: 1.5em;

  &:last-child {
    margin-bottom: 0;
  }
`;

export default StyledListItem;
